export enum Integration {
  ApplePay = 'ApplePay',
}

export const CardImage: Record<Integration, string> = {
  [Integration.ApplePay]: 'cash-app-afterpay-visa-card.svg',
}
